export default __webpack_public_path__ + "static/media/pencil.5edd7649.svg";